import { useState } from "react";
import $ from "jquery";

function ContactForm() {
  const getInitialType = () => {
    const params = new URLSearchParams(window.location.search);
    const path = window.location.pathname.toLowerCase().replace(/^\/+/, "");

    const rawCandidates = [
      params.get("type"),
      window.location.search.replace("?", ""),
      window.location.hash.replace("#", ""),
      path, // added fallback for /financement
    ];

    const raw = (rawCandidates.find(Boolean) || "").toLowerCase();

    const typeMap = {
      atelier: "Atelier",
      boutique: "Boutique",
      commande: "Commande",
      cuisinelocative: "Cuisine-Locative",
      "cuisine-locative": "Cuisine-Locative",
      question: "Informations",
      informations: "Informations",
      information: "Informations",
      recette: "Recette",
      traiteur: "Traiteur",
      financement: "Financement",
      autre: "Autre",
    };

    return typeMap[raw] || "Atelier";
  };

  const [selectedType, setSelectedType] = useState(getInitialType());
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = $(e.target);
    const isMissChecked = form.find("#miss").prop("checked");
    if (isMissChecked) {
      return;
    }

    $.ajax({
      type: "POST",
      url: form.attr("action"),
      data: form.serialize(),
      success: function (data) {
        console.log(data);
        setIsSubmitted(true);
      },
    });
  };

  return (
    <>
      <div className="contactWrapper">
        <div className="contatFormHeader">
          <p>Vous désirez passer une commande?</p>
          <p>Des questions?</p>
          <p>Des commentaires?</p>
        </div>
        {isSubmitted ? (
          <div className="contactSuccessMessage">
            <div className="successIcon">✓</div>
            <h2>Merci pour votre message!</h2>
            <p>Votre demande a bien été envoyée.</p>
            <p>Nous vous répondrons dans les plus brefs délais.</p>
            <button 
              className="backButton" 
              onClick={() => setIsSubmitted(false)}
            >
              Envoyer un autre message
            </button>
          </div>
        ) : (
          <div className="contactFormWrapper">
            <form
              id="contactForm"
              action="/server.php"
              method="post"
              onSubmit={(event) => handleSubmit(event)}
              acceptCharset="UTF-8"
            >
              <div className="formInputWrapper">
                <div className="contactFormFields">
                  <label htmlFor="type">Type</label>
                  <select
                    id="type"
                    name="type"
                    form="contactForm"
                    value={selectedType}
                    onChange={(e) => setSelectedType(e.target.value)}
                  >
                    <option value="Atelier">Atelier</option>
                    <option value="Boutique">Boutique</option>
                    <option value="Commande">Commande</option>
                    <option value="Cuisine-Locative">Cuisine Locative</option>
                    <option value="Financement">Financement</option>
                    <option value="Informations">Informations</option>
                    <option value="Recette">Recette</option>
                    <option value="Traiteur">Traiteur</option>
                    <option value="Autre">Autre</option>
                  </select>
                  <label className="required" htmlFor="prenom">Prénom</label>
                  <input id="prenom" type="text" name="prenom" required />
                  <label className="required" htmlFor="nom">Nom</label>
                  <input id="nom" type="text" name="nom" required />
                  <label className="required" htmlFor="email">Courriel</label>
                  <input type="email" name="email" id="email" required />
                  <label htmlFor="tel">
                    Téléphone <span>(Facultatif)</span>
                  </label>
                  <input type="tel" name="tel" id="tel" />
                </div>
                <div className="contactFormMessage">
                  <label className="required" htmlFor="message">Message</label>
                  <textarea name="message" id="message" cols="30" rows="10" required></textarea>
                </div>
                <input type="checkbox" name="miss" id="miss" />
              </div>
              <div className="contactButton">
                <button id="sendButton" type="submit">Envoyer</button>
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );
}

export default ContactForm;
